import { render, staticRenderFns } from "./PurchaseBill.vue?vue&type=template&id=8c7c786e&scoped=true&"
import script from "./PurchaseBill.vue?vue&type=script&lang=js&"
export * from "./PurchaseBill.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseBill.vue?vue&type=style&index=0&id=8c7c786e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c7c786e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDialog,VIcon,VRow})
